import { makeAutoObservable } from 'mobx';
import IGeoCoordinate from '../interfaces/IGeoCoordinate';

export default class MapMarkerStore {
    coordinates: IGeoCoordinate | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    draw(coordinates: IGeoCoordinate) {
        this.coordinates = coordinates;
    }

    isMatch(coordinates: IGeoCoordinate) {
        return this.coordinates?.latitude === coordinates.latitude
            && this.coordinates?.longitude === coordinates.longitude;
    }

    clear() {
        this.coordinates = null;
    }
}